<div class="card shadow rounded-3 mb-3">
  <div class="card-body">
    <h5 class="mb-3 text-center">{{ chartTitle }}</h5>

    <div class="d-flex flex-row flex-wrap">
      <!-- LEFT: All Line Charts -->
      <div style="width: 50%; padding-right: 1rem; max-height: 1200px; overflow-y: auto;">
        <div *ngFor="let dept of groupedData" class="mb-4">
          <highcharts-chart [Highcharts]="Highcharts"
                            [options]="dept.chartOptions"
                            style="width:100%; height: 300px; display: block;">
          </highcharts-chart>
        </div>
      </div>

      <!-- RIGHT: Single Combined Table -->
      <div style="width: 50%; padding-left: 1rem;">
        <div class="table-responsive">
          <table class="table table-hover align-middle text-sm border-1">
            <thead class="table-light text-center rounded-top">
              <tr>
                <th>{{ groupLabel }}</th>
                <th>📅 Month</th>
                <th class="text-success">Productivity%</th>
                <th class="text-primary">Occupancy%</th>
                <th class="text-warning">Attendance%</th>
                <th class="text-danger">Punctuality%</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let dept of groupedData">
                <ng-container *ngFor="let row of dept.records; let i = index">
                  <tr class="text-center">
                    <td *ngIf="i === 0" [attr.rowspan]="dept.records.length" class="fw-bold align-middle">
                      {{ dept.groupName }}
                    </td>
                    <td><strong>{{ row.MonthName }}</strong></td>
                    <td>{{ row.Productivity }}%</td>
                    <td>{{ row.Occupancy }}%</td>
                    <td>{{ row.Attendance }}%</td>
                    <td>{{ row.Punctuality }}%</td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
